import { TableTypeKey } from "../../types/edbMain/tableType.types";

type DefaultType = {
  [key in TableTypeKey]: {
    [k in string]: {
      maxWidth: string;
      minWidth: string;
    };
  };
};

export const DRUG_DB_WIDTH = {
  drugName: {
    maxWidth: "14.8rem",
    minWidth: "10rem",
  },
  otherDrugNames: {
    maxWidth: "14.8rem",
    minWidth: "10rem",
  },
  companyName: {
    maxWidth: "24.6rem",
    minWidth: "12.4rem",
  },
  modality: {
    maxWidth: "16.4rem",
    minWidth: "10.8rem",
  },
  target: {
    maxWidth: "16.4rem",
    minWidth: "10.8rem",
  },
  moa: {
    maxWidth: "24.6rem",
    minWidth: "12.4rem",
  },
  roa: {
    maxWidth: "16.4rem",
    minWidth: "10.8rem",
  },
  targetIndicationDisplay: {
    maxWidth: "24.6rem",
    minWidth: "12.8rem",
  },
  genericBiosimilar: {
    maxWidth: "8.4rem",
    minWidth: "8.4rem",
  },
  therapeuticsArea: {
    maxWidth: "16.4rem",
    minWidth: "10.8rem",
  },
  stage: {
    maxWidth: "10.4rem",
    minWidth: "7.2rem",
  },
};

export const DEALS_TABLE_WIDTH = {
  pressDate: {
    maxWidth: "8.8rem",
    minWidth: "6.4rem",
  },
  dealType: {
    maxWidth: "16.4rem",
    minWidth: "12rem",
  },
  seller: {
    maxWidth: "45rem",
    minWidth: "20rem",
  },
  buyer: {
    maxWidth: "45rem",
    minWidth: "20rem",
  },
  companies: {
    maxWidth: "90rem",
    minWidth: "40rem",
  },
  rightsScopes: {
    maxWidth: "23.2rem",
    minWidth: "16.4rem",
  },
  totalPaymentDollars: {
    maxWidth: "24.8rem",
    minWidth: "26.4rem",
  },
  highlightLabel: {
    maxWidth: "32rem",
    minWidth: "20rem",
  },
};

export const DEALS_V2_TABLE_WIDTH = {
  dealDate: {
    maxWidth: "8.8rem",
    minWidth: "6.4rem",
  },
  dealType: {
    maxWidth: "12rem",
    minWidth: "8.8rem",
  },
  partnerA: {
    maxWidth: "28rem",
    minWidth: "14.4rem`",
  },
  partnerB: {
    maxWidth: "28rem",
    minWidth: "14.4rem`",
  },
  keyRights: {
    maxWidth: "40rem",
    minWidth: "20rem",
  },
  financialTerms: {
    maxWidth: "28rem",
    minWidth: "20rem",
  },
  drugProfile: {
    maxWidth: "28rem",
    minWidth: "14.4rem`",
  },
  advisor: {
    maxWidth: "12rem",
    minWidth: "8.8rem",
  },
  contract: {
    maxWidth: "9.6rem",
    minWidth: "9.6rem",
  },
};

export const DRUG_APPROVAL_TABLE_WIDTH = {
  updateDate: {
    maxWidth: "12rem",
    minWidth: "9.2rem",
  },
  licenseHolder: {
    maxWidth: "24rem",
    minWidth: "17rem",
  },
  drugName: {
    maxWidth: "24rem",
    minWidth: "11.6rem",
  },
  otherDrugNames: {
    maxWidth: "24rem",
    minWidth: "11.6rem",
  },
  regulatoryAgency: {
    maxWidth: "12rem",
    minWidth: "8rem",
  },
  applicationType: {
    maxWidth: "12rem",
    minWidth: "8rem",
  },
  marketingStatus: {
    maxWidth: "14.4rem",
    minWidth: "12.2rem",
  },
  conditionIndication: {
    maxWidth: "656rem",
    minWidth: "38.4rem",
  },
};
export const EXPEDITED_PROGRAM_TABLE_WIDTH = {
  updateDate: {
    maxWidth: "12rem",
    minWidth: "9.2rem",
  },
  designatedCompany: {
    maxWidth: "24rem",
    minWidth: "17rem",
  },
  drugName: {
    maxWidth: "30rem",
    minWidth: "11.6rem",
  },
  otherDrugNames: {
    maxWidth: "30rem",
    minWidth: "11.6rem",
  },
  agency: {
    maxWidth: "12rem",
    minWidth: "8.8rem",
  },
  expeditedProgram: {
    maxWidth: "18rem",
    minWidth: "14rem",
  },
  designationStatus: {
    maxWidth: "16rem",
    minWidth: "11.8rem",
  },
  designatedTreatment: {
    maxWidth: "46rem",
    minWidth: "32rem",
  },
};
export const GUIDELINE_TABLE_WIDTH = {
  fdaDate: {
    maxWidth: "12rem",
    minWidth: "9.2rem",
  },
  topic: {
    maxWidth: "27.6rem",
    minWidth: "15.2rem",
  },
  agency: {
    maxWidth: "10.4rem",
    minWidth: "9.2rem",
  },
  guidance: {
    maxWidth: "123.8rem",
    minWidth: "70.4rem",
  },
  status: {
    maxWidth: "14rem",
    minWidth: "12rem",
  },
};
export const CLINICAL_TRIALS_DB_WIDTH = {
  studyTitle: {
    maxWidth: "auto",
    minWidth: "auto",
  },
  nctNumber: {
    maxWidth: "10.4rem",
    minWidth: "10.4rem",
  },
  studyStatus: {
    maxWidth: "10.4rem",
    minWidth: "10.4rem",
  },
  inclusionCriteriaDiagnostic: {
    maxWidth: "24rem",
    minWidth: "auto",
  },
  interventions: {
    maxWidth: "29.6rem",
    minWidth: "auto",
  },
  sponsor: {
    maxWidth: "14.4rem",
    minWidth: "14.4rem",
  },
  normalizedPhase: {
    maxWidth: "7.2rem",
    minWidth: "8.8rem",
  },
};

const REGULATORY_GUIDELINE_TABLE_WIDTH = {
  updatedDate: {
    maxWidth: "8rem",
    minWidth: "8rem",
  },
  issuedDate: {
    maxWidth: "8rem",
    minWidth: "8rem",
  },
  agency: {
    maxWidth: "12.2rem",
    minWidth: "10rem",
  },
  agencyDivision: {
    maxWidth: "16rem",
    minWidth: "8.1rem",
  },
  documentNumber: {
    maxWidth: "16rem",
    minWidth: "8.9rem",
  },
  documentType: {
    maxWidth: "12.8rem",
    minWidth: "8.9rem",
  },
  title: {
    maxWidth: "16rem",
    minWidth: "11.2rem",
  },
  summary: {
    maxWidth: "auto",
    minWidth: "20rem",
  },
  topicCategory: {
    maxWidth: "12rem",
    minWidth: "8.8rem",
  },
  subCategory: {
    maxWidth: "12rem",
    minWidth: "10rem",
  },
  status: {
    maxWidth: "8.8rem",
    minWidth: "7.2rem",
  },
  language: {
    maxWidth: "8.5rem",
    minWidth: "8.5rem",
  },
  sourceFile: {
    maxWidth: "8.8rem",
    minWidth: "7.2rem",
  },
};

const COMPANY_SEARCH_TABLE_WIDTH = {
  dateOfEstablishment: {
    maxWidth: "11.6rem",
    minWidth: "8.8rem",
  },
  companyName: {
    maxWidth: "18.6rem",
    minWidth: "12rem",
  },
  categoryType: {
    maxWidth: "12rem",
    minWidth: "9.6rem",
  },
  functionalTags: {
    maxWidth: "12rem",
    minWidth: "9.6rem",
  },
  headquartersLocation: {
    maxWidth: "16rem",
    minWidth: "9.6rem",
  },
  companyDescription: {
    maxWidth: "24rem",
    minWidth: "14.4rem",
  },
  stockInfo: {
    maxWidth: "12.8rem",
    minWidth: "10.8rem",
  },
  mainAsset: {
    maxWidth: "auto",
    minWidth: "33.6rem",
  },
  latestFunding: {
    maxWidth: "16rem",
    minWidth: "12.8rem",
  },
  link: {
    maxWidth: "4.4rem",
    minWidth: "4.4rem",
  },
};

export const PUBLICATION_TABLE_WIDTH = {
  date: {
    maxWidth: "11.6rem",
    minWidth: "9.6rem",
  },
  topicType: {
    maxWidth: "11.2rem",
    minWidth: "6.8rem",
  },
  journal: {
    maxWidth: "8.8rem",
    minWidth: "8rem",
  },
  issn: {
    maxWidth: "9.6rem",
    minWidth: "9.6rem",
  },
  publisher: {
    maxWidth: "12rem",
    minWidth: "9.6rem",
  },
  title: {
    maxWidth: "22rem",
    minWidth: "10rem",
  },
  abstract: {
    maxWidth: "auto",
    minWidth: "14.8rem",
  },
  authorList: {
    maxWidth: "12.8rem",
    minWidth: "8rem",
  },
  affiliationList: {
    maxWidth: "20rem",
    minWidth: "10rem",
  },
  mainLabelInformationList: {
    maxWidth: "20rem",
    minWidth: "17.4rem",
  },
  links: {
    maxWidth: "9.6rem",
    minWidth: "9.6rem",
  },
  citedBy: {
    maxWidth: "6.4rem",
    minWidth: "6.4rem",
  },
  sourceFile: {
    maxWidth: "8rem",
    minWidth: "8rem",
  },
};

export const DETAIL_TABLE_WIDTH = {
  default: {
    maxWidth: "100%",
    minWidth: "100%",
  },
};

const CLINICAL_REGISTRY_SEARCH_TABLE_WIDTH = {
  studyStart: {
    maxWidth: "9.6rem",
    minWidth: "8rem",
  },
  studyCompletion: {
    maxWidth: "10.4rem",
    minWidth: "10.4rem",
  },
  registryId: {
    maxWidth: "12.8rem",
    minWidth: "8.8rem",
  },
  studyType: {
    maxWidth: "10.8rem",
    minWidth: "10.8rem",
  },
  studyTitle: {
    maxWidth: "auto",
    minWidth: "10.4rem",
  },
  sponsor: {
    maxWidth: "24rem",
    minWidth: "12rem",
  },
  organization: {
    maxWidth: "24rem",
    minWidth: "12rem",
  },
  drug: {
    maxWidth: "12rem",
    minWidth: "8rem",
  },
  targetIndication: {
    maxWidth: "17.6rem",
    minWidth: "12rem",
  },
  phase: {
    maxWidth: "8rem",
    minWidth: "6.8rem",
  },
  siteCountry: {
    maxWidth: "12rem",
    minWidth: "8rem",
  },
  status: {
    maxWidth: "10.4rem",
    minWidth: "8rem",
  },
  enrollment: {
    maxWidth: "9.6rem",
    minWidth: "7.2rem",
  },
};

export const TABLE_WIDTH: DefaultType = {
  drug: DRUG_DB_WIDTH,
  deals: DEALS_TABLE_WIDTH,
  dealsV2: DEALS_V2_TABLE_WIDTH,
  drugDetailDeals: {},
  drugApproval: DRUG_APPROVAL_TABLE_WIDTH,
  expeditedProgram: EXPEDITED_PROGRAM_TABLE_WIDTH,
  guideline: GUIDELINE_TABLE_WIDTH,
  clinicalTrials: CLINICAL_TRIALS_DB_WIDTH,
  ventureCapital: {},
  publication: PUBLICATION_TABLE_WIDTH,
  crl: {},
  detail: DETAIL_TABLE_WIDTH,
  publicationResultMetrics: {},
  clinicalResult: {},
  relatedDeals: {},
  regulatoryGuideline: REGULATORY_GUIDELINE_TABLE_WIDTH,
  companySearch: COMPANY_SEARCH_TABLE_WIDTH,
  clinicalRegistry: CLINICAL_REGISTRY_SEARCH_TABLE_WIDTH,
};
